<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'专区编码'">
              <a-input  v-model="queryParam.siteCode" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'专区名称'">
              <a-input  v-model="queryParam.siteName" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'状态'">
              <j-dict-select-tag  v-model="queryParam.status" dictCode="empzone_site_status" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('员工专区站点表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->
        <span slot="action" slot-scope="text, record">
          <a @click="publish(record)" v-if="record.status == 'N'">上線</a>
          <a-divider type="vertical" v-if="record.status == 'N'"/>

          <a @click="unPublish(record)" v-if="record.status == 'Y'">下線</a>
          <a-divider type="vertical" v-if="record.status == 'Y'"/>

          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <empzone-site-modal ref="modalForm" @ok="modalFormOk"></empzone-site-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpzoneSiteModal from './modules/EmpzoneSiteModal'
  import { httpAction, getAction, postAction,putAction } from '@/api/manage'

  export default {
    name: 'EmpzoneSiteList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpzoneSiteModal
    },
    data () {
      return {
        description: '员工专区站点表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'专区名称',
            align:"center",
            dataIndex: 'siteName'
          },
          {
            title:'专区编码',
            align:"center",
            dataIndex: 'siteCode'
          },
          {
            title:'適用範圍',
            align:"center",
            dataIndex: 'siteArea_dictText',
            customRender:function (text,row,index) {
              return row.siteArea_dictText+'-'+row.siteEmpType_dictText
            }
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'創建人',
            align:"center",
            dataIndex: 'creater'
          },
          {
            title:'創建時間',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text,row,index) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/empzone/site/pagelist",
          delete: "/empzone/site/delete",
          deleteBatch: "/empzone/site/empzonesite/batch",
          exportXlsUrl: "/empzone/site/export-xls",
          importExcelUrl: "empzone/site/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      unPublish(record){
        let data = Object.assign({}, record)
        data.status = "N";
        this.confirmLoading = true;
        putAction('/empzone/site/edit',data).then((res)=>{
          if(res.success){
            this.$message.success("操作成功");
            this.searchQuery();
          }else{
            this.$message.warning("操作失敗");
          }
        }).finally(() => {
          this.confirmLoading = false;
        })
      },
      publish(record){
        let data = Object.assign({}, record)
        data.status = "Y";
        this.confirmLoading = true;
        putAction('/empzone/site/edit',data).then((res)=>{
          if(res.success){
            this.$message.success("操作成功");
            this.searchQuery();
          }else{
            this.$message.warning("操作失敗");
          }
        }).finally(() => {
          this.confirmLoading = false;
        })
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'siteCode',text:'站点code(应用code)',dictCode:''})
        fieldList.push({type:'string',value:'siteName',text:'站点名称',dictCode:''})
        fieldList.push({type:'string',value:'status',text:'状态(Y:上架；N:下架)',dictCode:''})
        fieldList.push({type:'string',value:'siteDesc',text:'站点介绍',dictCode:''})
        fieldList.push({type:'string',value:'siteArea',text:'国家/地区',dictCode:''})
        fieldList.push({type:'string',value:'siteEmpType',text:'员工类型',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
